// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"145":"cee15c82","248":"df7b74a4","418":"33f95e99","735":"829433fa","762":"4d28a7fc","966":"9775000b"}[chunkId] + ".chunk.css";
};